(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cb-collection-pills"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cb-pills')) return;
    // One line at every width (Design QA, 11 Oct 2026). The row runs from the content edge to the screen's right
    // edge; when the pills still don't fit it scrolls sideways inside itself (never the page), snapping to pill
    // starts. It opens with the lit pill in view, its start on the content edge (never centred). Fades: on the
    // right while more pills sit past the edge (cb-pills--more), on the left once scrolled from the start
    // (cb-pills--scrolled). Runs again when filters re-render the section.
    class CbPills extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.cb-pills__list');
        if (!this.list) return;
        this.extra = 0;
        this.width = 0;
        this.update = () => {
          const l = this.list;
          const overflow = l.scrollWidth > l.clientWidth + 1;
          this.classList.toggle('cb-pills--more', overflow && l.scrollLeft + l.clientWidth < l.scrollWidth - 2);
          this.classList.toggle('cb-pills--scrolled', overflow && l.scrollLeft > 1);
        };
        this.onResize = () => {
          this.raf = 0;
          if (!this.isConnected) return;
          // Place again when the row's width changes, or the pills' widths do (the web font loading), as long as
          // the shopper hasn't touched the row (the browser itself re-snaps the scroll when the pills resize, so
          // the scroll position can't tell).
          const l = this.list;
          if (l.clientWidth !== this.width || (!this.touched && l.scrollWidth !== this.scrollW)) this.place();
          this.update();
        };
        this.place();
        this.update();
        this.list.addEventListener('scroll', this.update, { passive: true });
        this.touch = () => {
          this.touched = true;
        };
        ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach((type) => this.list.addEventListener(type, this.touch, { passive: true }));
        // Resize work waits for the next frame (Technical QA, 11 Oct 2026): place() may change the row's end
        // padding, and doing that inside the observer's callback re-triggers it in the same frame ("ResizeObserver
        // loop completed with undelivered notifications").
        this.schedule = () => {
          if (this.raf) cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(this.onResize);
        };
        if (window.ResizeObserver) {
          this.observer = new ResizeObserver(this.schedule);
          this.observer.observe(this.list);
          this.list.querySelectorAll(':scope > li').forEach((li) => this.observer.observe(li));
        } else {
          window.addEventListener('resize', this.schedule);
        }
      }
      // Start with the lit pill in view, a pill's start on the content edge (never centred): the lit pill's
      // own, or near the end of the row the earliest pill start that still shows the lit pill whole. When the
      // row's end would stop the scroll part-way through a pill, just enough end space is added to land on it
      // (this.extra; written only when it changes).
      place() {
        const l = this.list;
        this.width = l.clientWidth;
        const style = getComputedStyle(l);
        // The row's own end padding and scroll range, without the end space added earlier.
        const end = (parseFloat(style.paddingRight) || 0) - this.extra;
        const max = l.scrollWidth - this.extra - l.clientWidth;
        const current = this.querySelector('.cb-pills__link--current');
        if (!current || max <= 1) return this.settle(0, 0, end);
        const item = current.parentElement;
        // Exact positions within the row (offsetLeft and offsetWidth round to whole pixels: Firefox put the lit
        // pill half a pixel under the fade).
        const box = l.getBoundingClientRect();
        const left = (el) => el.getBoundingClientRect().left - box.left - l.clientLeft + l.scrollLeft;
        const right = (el) => left(el) + el.getBoundingClientRect().width;
        // The left fade covers the page margin (up to the content edge, --cb-pills-start) and the right fade the
        // last --cb-pills-fade of the row (the same values the mask uses): the lit pill counts as in view only
        // clear of both, never half under a fade.
        const start = parseFloat(style.paddingLeft) || 0;
        const fade = parseFloat(style.getPropertyValue('--cb-pills-fade')) || 0;
        const clear = Math.max(end, fade);
        if (left(item) >= start && right(item) <= l.clientWidth - clear) return this.settle(0, 0, end);
        const room = l.clientWidth - start - clear;
        let target = item;
        if (left(item) - start > max) {
          for (let prev = item.previousElementSibling; prev; prev = prev.previousElementSibling) {
            if (right(item) - left(prev) > room) break;
            target = prev;
            if (left(target) - start <= max) break;
          }
        }
        const want = Math.ceil(left(target) - start);
        return this.settle(want, Math.max(0, want - max), end);
      }
      settle(scroll, extra, end) {
        if (extra !== this.extra) {
          this.extra = extra;
          this.list.style.paddingRight = extra ? `${end + extra}px` : '';
        }
        this.list.scrollLeft = scroll;
        this.scrollW = this.list.scrollWidth;
      }
      disconnectedCallback() {
        if (!this.list) return;
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
        this.list.removeEventListener('scroll', this.update);
        ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach((type) => this.list.removeEventListener(type, this.touch));
        if (this.observer) this.observer.disconnect();
        else window.removeEventListener('resize', this.schedule);
      }
    }
    customElements.define('cb-pills', CbPills);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cb-shop-lines"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cb-lines-row')) return;
    // Marks whether the row overflows and which ends still have buttons behind them, so the CSS
    // fades (and puts an arrow on) only those edges. No fade when everything fits.
    class CbLinesRow extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.cb-lines__list');
        if (!this.list) return;
        this.onScroll = () => this.update();
        this.list.addEventListener('scroll', this.onScroll, { passive: true });
        this.onClick = (event) => {
          const button = event.target.closest('[data-cb-lines-dir]');
          if (!button) return;
          const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const dir = Number(button.getAttribute('data-cb-lines-dir')) || 1;
          // 'auto', not 'instant': older Safari rejects 'instant'.
          this.list.scrollBy({ left: dir * this.list.clientWidth * 0.7, behavior: still ? 'auto' : 'smooth' });
        };
        this.addEventListener('click', this.onClick);
        if ('ResizeObserver' in window) {
          // Next frame, so the attribute change never lands inside the observer's own loop.
          this.observer = new ResizeObserver(() => requestAnimationFrame(() => this.update()));
          this.observer.observe(this.list);
        }
        this.update();
      }
      disconnectedCallback() {
        if (this.list) this.list.removeEventListener('scroll', this.onScroll);
        this.removeEventListener('click', this.onClick);
        if (this.observer) this.observer.disconnect();
      }
      update() {
        const list = this.list;
        const max = list.scrollWidth - list.clientWidth;
        const left = Math.abs(list.scrollLeft);
        this.toggleAttribute('data-more-start', max > 1 && left > 4);
        this.toggleAttribute('data-more-end', max > 1 && left < max - 4);
      }
    }
    customElements.define('cb-lines-row', CbLinesRow);
  })();
  } catch(e) { console.error(e); }
})();

})();
